<script setup>
  import { computed } from 'vue';
  import windInfo from '@/data/windInfo.json';

  const props = defineProps({
    directions: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: '30px'
    }
  });

  const order = windInfo.cardinalDirections;
  const sliceDeg = 360 / order.length;
  const cx = 50;
  const cy = 50;
  const r = 50;

  const wedges = computed(() => order.map((name, i) => {
    const startAngle = i * sliceDeg - sliceDeg / 2;
    const endAngle = startAngle + sliceDeg;
    const [x1, y1] = pointOnCircle(startAngle);
    const [x2, y2] = pointOnCircle(endAngle);
    const path = `M ${cx} ${cy} L ${x1.toFixed(3)} ${y1.toFixed(3)} A ${r} ${r} 0 0 1 ${x2.toFixed(3)} ${y2.toFixed(3)} Z`;
    return {
      name,
      path,
      selected: props.directions.includes(name),
    };
  }));

  const dividers = computed(() => order.map((_, i) => {
    const angle = i * sliceDeg - sliceDeg / 2;
    const [x, y] = pointOnCircle(angle);
    return { x: x.toFixed(3), y: y.toFixed(3) };
  }));

  function pointOnCircle(angleDeg) {
    const rad = (angleDeg - 90) * Math.PI / 180;
    return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
  }
</script>

<template>
  <svg
    class="jwx-wind-dir-pie"
    :style="{ width: props.size, height: props.size }"
    viewBox="0 0 100 100"
    aria-hidden="true"
  >
    <path
      v-for="wedge in wedges"
      :key="wedge.name"
      :d="wedge.path"
      :fill="wedge.selected ? 'var(--jwx-text-color-subtle)' : 'var(--jwx-surface-level-1)'"
    />
    <line
      v-for="(d, i) in dividers"
      :key="i"
      :x1="cx"
      :y1="cy"
      :x2="d.x"
      :y2="d.y"
      stroke="var(--jwx-surface)"
      stroke-width="3"
    />
  </svg>
</template>

<style scoped>
  .jwx-wind-dir-pie {
    display: inline-block;
    border-radius: 50%;
    flex-shrink: 0;
  }
</style>
